require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-unterrabnitz-schwendgraben.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-unterrabnitz-schwendgraben");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-unterrabnitz-schwendgraben!./.cache/json/betreuungseinrichtungen-oberpullendorf-unterrabnitz-schwendgraben.json
// module id = 996
// module chunks = 231608221292675